import React from 'react';
import { string, arrayOf, oneOf } from 'prop-types';
import { getWidgetByVersion } from '../../versions/helpers/getWidgetByVersion';
import { Domain } from '../../hooks/useDomain';
import { Language } from '../../hooks/useLanguage';
import { AppContext } from '../../hooks/useAppContext';
import { gigShape, widgetType } from '../../utils/propTypes';
import { VERSIONS, DOMAINS } from '../../../../constants';

export const App = ({ version, domain, widgetLocalization, ...rest }) => {
    const WidgetByVersion = getWidgetByVersion(version);

    /**
     * @todo
     * Refactor custom contexts to app context
     */
    return (
        <AppContext version={version}>
            <Domain value={domain}>
                <Language value={widgetLocalization}>
                    <WidgetByVersion {...rest} />
                </Language>
            </Domain>
        </AppContext>
    );
};

App.propTypes = {
    affiliateId: string,
    afp: string,
    afp1: string,
    brand: string,
    gigs: arrayOf(gigShape),
    exploreSlug: string,
    utmCampaign: string,
    version: oneOf([VERSIONS.V1, VERSIONS.V2]),
    domain: oneOf([DOMAINS.FIVERR, DOMAINS.BUSINESS]),
    widgetLocalization: string,
    widgetMoreButton: string,
    widgetTitle: string,
    widgetType,
};
